(function () {
  if (!document.body.classList.contains('form')) return this;

  const formElement = document.querySelector("form");

  const textElement = formElement.querySelectorAll("input[type=text]");
  const textCount = textElement.length;
  let textArray = [];
  for (let i = 0; i < textCount; i++) {
    textArray.push(textElement[i].required = true);
    textArray.push(textElement[i].setAttribute("aria-required", "true"));
  };

  const emailElement = formElement.querySelectorAll("input[type=email]");
  const emailCount = emailElement.length;
  let emailArray = [];
  for (let i = 0; i < emailCount; i++) {
    emailArray.push(emailElement[i].required = true);
    emailArray.push(emailElement[i].setAttribute("aria-required", "true"));
  };

  const selectElement = formElement.querySelector("select");
  selectElement.required = true;

  const radioElement = formElement.querySelectorAll("input[type=radio]");
  const radioCount = radioElement.length;
  let radioArray = [];
  for (let i = 0; i < radioCount; i++) {
    radioArray.push(radioElement[i].required = true);
  };
  
  const agreeElement = document.getElementById('agree-1');
  agreeElement.required = true;

  const hobbiesElment = document.getElementById('hobbies')
  hobbiesElment.required = false;
  hobbiesElment.removeAttribute("aria-required");
  const problemsLearningElment = document.getElementById('problemsLearning')
  problemsLearningElment.required = false;
  problemsLearningElment.removeAttribute("aria-required");
  const problemsLifeElment = document.getElementById('problemsLife')
  problemsLifeElment.required = false;
  problemsLifeElment.removeAttribute("aria-required");
  const sensoryElment = document.getElementById('SensoryHypersensitivityOther')
  sensoryElment.required = false;
  sensoryElment.removeAttribute("aria-required");
  const whatKindOfHelpElment = document.getElementById('whatKindOfHelp')
  whatKindOfHelpElment.required = false;
  whatKindOfHelpElment.removeAttribute("aria-required");

})();
